const MOOD_EMOJIS: Record<number, string> = {
  1: "😞",
  2: "😕",
  3: "😐",
  4: "😊",
  5: "😄",
  6: "🤩"
};

export function studentMoodEmoji(value?: number | null) {
  return MOOD_EMOJIS[value ?? 0] ?? "❓";
}

export function studentDateLabel(value: string) {
  const dateOnly = value.slice(0, 10);
  return new Date(`${dateOnly}T12:00:00`).toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  });
}
